import type { ListParams } from '@nucleus-commerce/admin-kit/index-table';

/** Query key factory. Every key starts with 'applications' so a decision invalidates all of it. */
export const applicationKeys = {
  all: ['applications'] as const,
  lists: () => [...applicationKeys.all, 'list'] as const,
  list: (params: ListParams) => [...applicationKeys.lists(), params] as const,
  counts: () => [...applicationKeys.all, 'counts'] as const,
  details: () => [...applicationKeys.all, 'detail'] as const,
  detail: (id: string) => [...applicationKeys.details(), id] as const,
};
